import Vue from 'vue'

export const userKey = '__knowledge_user'
export const baseApiUrl = 'https://api.bomjesusgo.ra2s.com.br'
export const baseApiRel = 'https://api.bomjesusgo.ra2s.com.br'
// export const baseApiRel = 'http://localhost:3050'
// export const baseApiUrl = 'http://localhost:3050'
export const baseUrl = 'http://localhost:8080/'

export function showError (e) {
  if (e && e.response && e.response.data) {
    Vue.toasted.global.defaultError({ msg: e.response.data })
  } else if (typeof e === 'string') {
    Vue.toasted.global.defaultError({ msg: e })
  } else {
    Vue.toasted.global.defaultError()
  }
}

export default { baseApiUrl, baseApiRel, baseUrl, showError, userKey }
